import api from '../../api';

class FinancingStatus {
  getStatus() {
    return api.get('api/financeiro/status');
  }
}

export default new FinancingStatus();